import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import Layout from './components/layout/Layout';
import AgendaPage from './pages/agenda/AgendaPage';
import ClinicasPage from './pages/clinicas/Clinicas';
import HomePage from './pages/homepage/HomePage';
import PacientesPage from './pages/pacientes/Pacientes';
import RelatoriosPage from './pages/relatorios/Relatorios';
import './App.css';
import './index.css';
import './styles/transitions.css';

// Importando o RealtimeDataProvider
import { RealtimeDataProvider } from './contexts/RealtimeDataContext';
import PrescriptionPage from './pages/prescriptionPage/PrescriptionPage';
import UploadCidTuss from './pages/upload-cid-tuss/UploadCidTuss';

function App() {
  const location = useLocation();

  return (
    <RealtimeDataProvider>
      <Layout>
        <TransitionGroup>
          <CSSTransition key={location.key} timeout={300} classNames="fade">
            <Routes location={location}>
              <Route path="/" element={<HomePage />} />
              <Route path="/pacientes" element={<PacientesPage />} />
              <Route path="/clinicas" element={<ClinicasPage />} />
              <Route path="/relatorios" element={<RelatoriosPage />} />
              <Route path="/agenda" element={<AgendaPage />} />
              <Route path="/prescricao" element={<PrescriptionPage />} />
              <Route path="/upload-cid-tuss" element={<UploadCidTuss />} />
              <Route path="/consulta-tuss" element={<UploadCidTuss />} />
              <Route path="/consulta-cid" element={<UploadCidTuss />} />
            </Routes>
          </CSSTransition>
        </TransitionGroup>
      </Layout>
    </RealtimeDataProvider>
  );
}

export default App;
